import get from 'lodash/get';
import { CaseState } from 'app/area/case/types-store';

export const domainMetadata = (domainId: number, prop: string) =>
(
  state: CaseState
) => {
  const meta = get(state, `editing.metadata.domains[${domainId}]`);
  return { [prop]: get(meta, `${prop}.globalMatch`) };
};
